import { render, staticRenderFns } from "./TabDadosGerais.vue?vue&type=template&id=662ff7a8"
import script from "./TabDadosGerais.vue?vue&type=script&lang=js"
export * from "./TabDadosGerais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports